import loadable from '@loadable/component';

export const SpaceSiteWrapper = loadable(
  () => import(/* webpackChunkName: "space-site" */ './SpaceSiteWrapper'),
);
